import React, {FC} from 'react';
import {Form} from 'forms';
import {ItemWithPlaceholder} from '../ItemWithPlaceholder';
import {IWithDisabled} from 'models';

interface ITextInputProps extends IWithDisabled {
  label: string;
  name: string;
  value?: string;
  infoText?: string;
  autoFocus?: boolean;
  digitsOnly?: boolean;
  allowDecimal?: boolean;
  max?: string;
}

export const TextInputSelection: FC<ITextInputProps> = ({
  label,
  name,
  disabled = false,
  autoFocus = false,
  value = '',
  infoText,
  digitsOnly = false,
  allowDecimal = false,
  max,
}) => (
  <ItemWithPlaceholder label={label} hasItems infoText={infoText}>
    <Form.InputWithField
      name={name}
      type="text"
      disabled={disabled}
      value={value}
      autoFocus={autoFocus}
      digitsOnly={digitsOnly}
      allowDecimal={allowDecimal}
      max={max}
    />
  </ItemWithPlaceholder>
);
